import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Financing from "./pages/Financing";
import Contact from "./pages/Contact";
import Legal from "./pages/Legal";
import Eligibility from "./pages/Eligibility";
import EligibilityStatus from "./pages/EligibilityStatus";

export default function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/financing" element={<Financing />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/check-eligibility" element={<Eligibility />} />
          <Route path="/check-eligibility/status" element={<EligibilityStatus />} />
          <Route path="/privacy-policy" element={<Legal type="privacy" />} />
          <Route path="/terms-of-use" element={<Legal type="terms" />} />
        </Routes>
      </main>
      <Footer />
    </BrowserRouter>
  );
}
